import { render, staticRenderFns } from "./HomelyRemediesList.vue?vue&type=template&id=3a10d80d"
import script from "./HomelyRemediesList.vue?vue&type=script&lang=js"
export * from "./HomelyRemediesList.vue?vue&type=script&lang=js"
import style0 from "./HomelyRemediesList.vue?vue&type=style&index=0&id=3a10d80d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports